import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { FilterType } from '../../shared/enums/filter-type.enum';

@Injectable({
    providedIn: 'root',
})
export class EventsAnalyticsService {
    constructor(private readonly http: HttpClient) {}

    public organizationContactClicked(targetId: string) {
        this.http
            .post(`${environment.microservices.analytics.baseUrl}/api/v1/interactions/OrganizationContactClicked`, {
                targetId,
            })
            .subscribe();
    }

    public organizationDirectoryFiltersApplied(filters: FilterType[]) {
        this.http
            .post(`${environment.microservices.analytics.baseUrl}/api/v1/filtering/OrganizationDirectoryFiltersApplied`, {
                filters,
            })
            .subscribe();
    }

    public userContactClicked(targetId: string) {
        this.http
            .post(`${environment.microservices.analytics.baseUrl}/api/v1/interactions/UserContactClicked`, {
                targetId,
            })
            .subscribe();
    }

    public userDirectoryFiltersApplied(filters: FilterType[]) {
        this.http
            .post(`${environment.microservices.analytics.baseUrl}/api/v1/filtering/UserDirectoryFiltersApplied`, {
                filters,
            })
            .subscribe();
    }
}
